/**
 * Step 41 — XHR-based JSON request helper.
 *
 * Why: the Emergent preview environment installs a fetch interceptor that
 * eagerly consumes the response body on non-2xx responses. That breaks the
 * standard `await res.text()` / `await res.json()` pattern in our auth
 * pages because by the time our handler runs, the body has already been
 * read and `clone()` throws "Response body is already used".
 *
 * XHR is not intercepted, so we use it for the small handful of auth
 * endpoints. Returns `{ ok, status, data }` shaped like a fetch response
 * after json-parsing the body.
 */
export async function apiRequest(method, url, { body, withCredentials = true } = {}) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open(method, url, true);
    xhr.withCredentials = !!withCredentials;
    if (body !== undefined) xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.onload = () => {
      let data = {};
      const t = xhr.responseText || '';
      if (t) {
        try { data = JSON.parse(t); } catch { data = { raw: t }; }
      }
      resolve({ ok: xhr.status >= 200 && xhr.status < 300, status: xhr.status, data });
    };
    xhr.onerror = () => reject(new Error('Network error'));
    xhr.send(body !== undefined ? JSON.stringify(body) : null);
  });
}
